(function () {
    'use strict';

    angular.module("imApp").factory("businesscosService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3249,
                    parameters: parms || {}
                });
            },
            listBusinesses: function (parms) {
                return $ihttp.post({
                    method: 233,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
